import React, {lazy, Suspense} from 'react'

const EvangelizationPageLazy = lazy(() =>
    import('./EvangelizationPage')
)

const EvangelizationPage = props => (
    <Suspense fallback={null}>
        <EvangelizationPageLazy {...props} />
    </Suspense>
)

export default EvangelizationPage
